import { FC } from 'react';
import { formatPhoneNumber, presentText } from '../../utils/formatters';

/**
 * Clickable contact links for use inside table cells. Both stop click
 * propagation so they don't trigger the row's onClick (which typically opens
 * the contact). Render a muted "-" when the value is empty.
 */

interface TelLinkProps {
  value?: string | null;
  className?: string;
}

export const TelLink: FC<TelLinkProps> = ({ value, className }) => {
  const phone = presentText(value);
  if (!phone) return <span className="text-muted-foreground">-</span>;
  return (
    <a
      href={`tel:${phone}`}
      className={`text-primaryfortext hover:underline whitespace-nowrap ${className ?? ''}`}
      onClick={(event) => event.stopPropagation()}
    >
      {formatPhoneNumber(phone)}
    </a>
  );
};

interface EmailLinkProps {
  value?: string | null;
  className?: string;
}

export const EmailLink: FC<EmailLinkProps> = ({ value, className }) => {
  const email = presentText(value);
  if (!email) return <span className="text-muted-foreground">-</span>;
  return (
    <a
      href={`mailto:${email}`}
      className={`text-primaryfortext hover:underline ${className ?? ''}`}
      onClick={(event) => event.stopPropagation()}
    >
      {email}
    </a>
  );
};